export const ColorInputAccent = "#7B869B";
export const ColorInput = "#B5BCCB";
export const WhiteColor = "#FFFFFF";
export const BlueColor = "#3B85F7";
export const WhiteLightColor = "#F8F8F8";